export const cssSafeString = (name: string) =>
  encodeURIComponent(name)
    .toLowerCase()
    .replace(/\.|%[0-9a-z]{2}/gi, "")
    .replaceAll("-", "")
    .replace(/[0-9]/g, "");

export const getTextContentFromHtml = (html: string) =>
  new DOMParser().parseFromString(html, "text/html").body.textContent;
